<template>
<v-card class='mt-5' :class='calculatedClasses'>
  <v-sheet
    class="v-sheet--offset mx-auto"
    color="cyan"
    elevation="12"
    max-width="calc(100% - 32px)" >
      <v-toolbar class='elevation-10' :class="color" dense dark >
        <v-btn icon
          @click='get'
          :loading='getRequest.loading || loading' >
          <v-icon>person</v-icon>
        </v-btn>
        <v-tabs
          v-if='!isMobile'
          v-model="tab" :color="color" >
            <template class='hidden-xs-only' >
              <v-tab v-for='page in pages' :key='page.title' >{{page.title}}</v-tab>
            </template>
        </v-tabs>
        <template v-else >
          <v-toolbar-title >
            {{activePage.title}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu v-if='isMobile' bottom left
            class="v-tabs__div hidden-sm-and-up mr-0 pr-0" >
            <template v-slot:activator="{ on }">
              <a text class="v-tabs__item " v-on="on">
                MORE
                <v-icon>arrow_drop_down</v-icon>
              </a>
            </template>
            <v-list dense class='pa-0' >
              <v-list-tile
                v-for="(page, index) in pages"
                @click='setTab(index)'
                :key="page.title" >
                {{ page.title }}
              </v-list-tile>
            </v-list>
          </v-menu>
        </template>
        <v-spacer></v-spacer>
        <v-btn class='hidden-xs-only'
          v-if='withDone' @click='$emit("close")' flat text >Done</v-btn>
      </v-toolbar>
  </v-sheet>
  <tombstone v-if='getRequest.loading' ></tombstone>
  <v-card-text v-else >
    <!-- {{ relationshipId }} | {{ value }} -->
    <v-card-title v-text='activePage.title' class="title font-weight-light mb-2 hidden-xs-only">
      <v-spacer></v-spacer>
      <v-btn v-if='activePage.withSaveButton'
        color='primary'
        @click='save'
        :loading='saveRequest.loading' small >
        Save
      </v-btn>
    </v-card-title>
    <v-divider ></v-divider>
    <request-status :request='saveRequest' ></request-status>
    <component
      v-if='activePage.component'
      :is='activePage.component'
      :loading.sync='loading'
      v-bind='activePage.attrs'
      @reload='get' >
    </component>
  </v-card-text>
  <v-card-actions v-if='activePage.withSaveButton' >
    <v-btn flat
      v-if='withDone'
      @click='$emit("close")' small >
      Cancel
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn flat
      v-if='withDone'
      color='primary'
      @click='closeOnSave=true;save()'
      :loading='saveRequest.loading' small >
      Save and close
    </v-btn>
    <v-btn
      color='primary'
      @click='save'
      :loading='saveRequest.loading' small >
      Save
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import ClientContactDetails from '@/components/client/ClientContactDetails'
import MedicalAidDetails from './MedicalAidDetails'
import Referrers from './Referrers'
import ClientForms from './ClientForms'
import Person from './Person'
import Tombstone from '@/components/app/Tombstone'
import RequestStatus from '@/components/ui/RequestStatus'

export default {
  name: 'PatientInformationForm',
  components: { Tombstone, RequestStatus },
  props: {
    value: { type: Object },
    relationshipId: { required: true },
    touch: { type: Number, default: 0 },
    fetch: { type: Boolean, default: false },
    withDone: { type: Boolean, default: false },
    activeTab: { type: Number, default: 0 }
  },
  data () {
    return {
      tab: 0,
      closeOnSave: false,
      reqId: 'get-client',
      saveReqId: 'save-client',
      color: 'orange',
      relationship: {},
      loading: false,
      record: {patient: {}, medicalaid: {}}
    }
  },
  mounted () {
    if (this.fetch) {
      this.get()
    }
    if (this.activeTab !== null) {
      this.tab = this.activeTab
    }
  },
  // todo: debounce get
  watch: {
    value () {
      if (this.value) { this.record = this.value }
    },
    relationshipId () {
      this.get()
    },
    touch () {
      this.get()
    },
    activeTab () {
      this.tab = this.activeTab
    },
    getRequestStatus () {
      if (this.getRequestStatus === 200) {
        this.record = this.remoteRecord
        this.relationship = this.remoteRelationship
        this.$store.commit('addClientDetail', this.relationship)
      }
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 200 && this.closeOnSave === true) {
        this.$emit('close')
      }
    }
  },
  methods: {
    get () {
      if (this.relationshipId) {
        this.$appointmentguru
          .resource('practitioner.v3.relationships')
          .id(this.reqId)
          .get(this.relationshipId)
      } else {
        console.error('Could not fetch relationship. Relationship is null')
      }
    },
    setTab (index) {
      console.log(index)
      this.tab = index
    },
    save () {
      let data = this.record
      if (data) {
        if (this.accountPersonIsPatient === true) {
          data['account_person_id'] = this.record.patient.id
          delete data['account_person']
        }
        data = JSON.stringify(data)
        this.$medicalaidguru
          .resource('record.v2')
          .id(this.saveReqId)
          .save(this.record.id, data)
      }
    }
  },
  computed: {
    activePage () {
      return this.pages[this.tab]
    },
    getRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    getRequestStatus () {
      return this.getRequest.status
    },
    saveRequest () {
      return this.$store.getters.getRequestById(this.saveReqId, true)
    },
    saveRequestStatus () {
      return this.saveRequest.status
    },
    remoteRelationship () {
      return this.getObjectPath(this.getRequest, 'result.data', {})
    },
    remoteClient () {
      return this.getObjectPath(this.getRequest, 'result.data.client', {})
    },
    remoteRecord () {
      return this.getObjectPath(this.getRequest, 'result.data.record', {})
    },
    pages () {
      return [
        {
          title: 'Contact details',
          component: ClientContactDetails,
          withSaveButton: false,
          attrs: {
            value: this.relationship,
            withFetch: false,
            withEdit: true,
            editOnly: true,
            relationshipId: this.relationshipId
          }
        },
        {
          title: 'Medical Aid',
          component: MedicalAidDetails,
          withSaveButton: true,
          attrs: {
            value: this.medicalaid,
            patientData: this.remoteClient
          }
        },
        {
          title: 'More information',
          withSaveButton: true,
          component: Person,
          attrs: {
            value: this.patient,
            withTitle: false
          }
        },
        {
          title: 'Forms',
          component: ClientForms,
          withSaveButton: false,
          attrs: {
            relationshipId: this.relationshipId
          }
        },
        {
          title: 'Referrers',
          component: Referrers,
          withSaveButton: false,
          attrs: {
            record: this.record
          }
        }
      ]
    },
    medicalaid () {
      return this.getObjectPath(this.record, 'medical_aid', {})
    },
    patient () {
      return this.getObjectPath(this.record, 'patient', {})
    },
    isMobile () {
      return this.$vuetify.breakpoint.xs
    },
    calculatedClasses () {
      if (this.isMobile) {
        return 'mx-0'
      } else {
        return 'mx-4'
      }
    }
  }
}
</script>
<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// PatientInformationForm.vue?0fdbecdf